<template>
    <section class="w-full flex flex-col bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="container mx-auto">
            <div class="px-4 sm:px-8 flex flex-row flex-wrap w-full pb-4 sm:pb-8">
                <div v-if="visibleMenu.length"
                    class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-8 mt-4 sm:mt-8">
                    <tile v-for="(item, index) in visibleMenu" :key="index" :item="item"></tile>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Tile from "../../components/shared/Tile.vue";

export default {
    name: "training-module",
    components: {
        Tile,
    },
    data() {
        return {
            menu: [
                {
                    id: 1,
                    isActive: true,
                    isImage: true,
                    path: "/internship-clinical-placement",
                    title: "Internship / Clinical Placement / On the Job Training",
                    icon: ``,
                    image: require('../../assets/images/icons/img3.png'),
                    isNotificationNumber: 0,
                    popOverContent: ``,
                    showPopOver: false,
                    permission: 'internship',
                },
                {
                    id: 2,
                    isActive: true,
                    isImage: true,
                    path: "/internship-report",
                    title: "Internship Report",
                    icon: ``,
                    image: require('../../assets/images/icons/img2.png'),
                    isNotificationNumber: 0,
                    popOverContent: ``,
                    showPopOver: false,
                    permission: 'internship-report',
                },
            ],
        };
    },
    computed: {
        visibleMenu() {
            return this.menu.filter((item) => !item.permission || this.hasPermission(item.permission));
        }
    },
    methods: {
        hasPermission(crudName) {
            const permissions = this.$store.getters.permissions || '';
            const permissionsArray = permissions.split(",");
            return permissionsArray.includes(crudName);
        },
    }
}
</script>